// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorText_wrap__mVbBB"};